<template lang="pug">
  section.looper
    router-link.article-link(:to="article.slug" v-for="(article, index) in articles" :key="index")
      ArticleItem(:firstname="article.firstname", :lastname="article.lastname", :rudo="article.video", :image="article.slug", :age="article.age", :city="article.city", :prize="article.prize", :capital="article.capital", :employees="article.employees", :lesson="article.lesson", :position="isEvenOrOdd(index + 1)", :prizetitle="article.prizetitle")
</template>
<script>
import ArticleItem from '@/components/BancoEstado/ArticleItem'

export default {
  props: {
    articles: Array
  },
  components: {
    ArticleItem
  },
  computed: {
    title(firstname, lastname){
      return `${firstname} ${lastname}`
    },
  },
  methods: {
    isEvenOrOdd(index){
      const ret = index % 2 == 0 ? 'even' : 'odd'
      return ret
    }
  }

}

</script>




